<div class="trade-instructions-wrapper">
  @if (data?.securityType === 'EQUITY' || data?.securityType === 'OPTION' || isTestMode) {
    @if (layoutFieldsShowHide?.limitInstructionTextVisible) {
      <div>
        <strong>Enter a limit price or select a price option. If you select Last trade, Bid, Ask, or Midpoint, the latest
        value at time of your order submission will be used.</strong>
      </div>
    }
    @if (destinationInstructionText) {
      <div>
        <strong>{{destinationInstructionText}}</strong>
      </div>
    }
    <div class="trade-instructions">
      <div class="trade-instructions-item">
        <p class="item-label bold">Order Type</p>
        <irb-dropdown-filter #orderTypeElem (search)="getOrderTypes($event)"
          [(value)]="orderTypeSelected"
          [disabled]="orderTypesDisabled || pfs.updateOrderPayload.disableMode || mainPropertiesDisabled"
          size="16" hoverPanelWidth="155"
          [placeholder]="orderTypePlaceHolder ? orderTypePlaceHolder.name : ((actionType==='MultiEdit' && !pfs.updateOrderPayload.isModified) ? 'Various' : ' ')"
        (selection)="orderTypeChanged($event);setMultiEditPrice()"></irb-dropdown-filter>
      </div>
      @if (optionOrderTypeVisible) {
        <div class="trade-instructions-item">
          <p class="item-label bold">Credit/Debit</p>
          <irb-dropdown-filter #optionOrderTypeElem (search)="getOptionOrderTypes($event)"
            [(value)]="optionOrderTypeSelected"
            [disabled]="optionOrderTypeDisabled || pfs.updateOrderPayload.disableMode || mainPropertiesDisabled"
            size="16" hoverPanelWidth="155"
            [placeholder]="actionType==='MultiEdit'? 'Various': ' '"
          (selection)="optionOrderTypeChanged($event)"></irb-dropdown-filter>
        </div>
      }
      @if (priceVisible) {
        <div class="trade-instructions-item">
          <p class="item-label bold">&nbsp;</p>
          @if (!priceTypeVisible) {
            <p class="item-label inline bold">{{priceLabel}}</p>
          }
          @if (priceTypeVisible) {
            <span><irb-dropdown-filter #priceTypesElem (search)="getPriceTypes($event)"
              [(value)]="priceTypeSelected"
              [disabled]="priceTypeDisabled || pfs.updateOrderPayload.disableMode || mainPropertiesDisabled"
              size="16" hoverPanelWidth="155"
              [placeholder]="actionType==='MultiEdit'? 'Various': ' '"
            (selection)="priceTypeChanged($event)"></irb-dropdown-filter>&nbsp;</span>
          }
          @if (priceValueVisible && !isShowMarketPrice && !(priceDisabled || pfs.updateOrderPayload.disableMode || mainPropertiesDisabled)) {
            <irb-number-text-box #priceElem
              [(value)]="price"
              [placeholder]="(isShowPriceVarious && actionType==='MultiEdit') ? 'Various' : ''"
              [places]="priceConstraints.places" [attr.pattern]="priceConstraints.pattern"
              [min]="priceConstraints.min" [max]="priceConstraints.max"
              [invalidRangeMessage]="priceRangeMessage"
              (focusin)="onPriceTapped($event)" (focusout)="onPriceChange($event)"
            width="90px"></irb-number-text-box>
          }
          @if (isShowMarketPrice) {
            <input pInputText type="text" [value]="'M'" class="market-price" disabled="disabled">
          }
          @if (priceValueVisible && !isShowMarketPrice && (priceDisabled || pfs.updateOrderPayload.disableMode || mainPropertiesDisabled)) {
            <input
              type="text" pInputText [value]="!price ? '' : formatCurrency(price)" class="market-price" disabled="disabled"
              [placeholder]="isShowPriceVarious ? 'Various' : ''">
          }
        </div>
      }
      @if (limitPriceVisible) {
        <div class="trade-instructions-item">
          <p class="item-label  bold">Limit Price</p>
          <irb-number-text-box #limitPriceElem [disabled]="limitPriceDisabled || pfs.updateOrderPayload.disableMode || mainPropertiesDisabled"
            [(value)]="limitPrice"
            [placeholder]="(isShowLimitPriceVarious && actionType==='MultiEdit') ? 'Various' : ''"
            places="2" min="0" max="1000000000"
            [invalidRangeMessage]="priceRangeMessage"
            (focusin)="onLimitPriceTapped($event)" (focusout)="onLimitPriceChange($event)"
          width="90px"></irb-number-text-box>
        </div>
      }
      @if (stopPriceVisible) {
        <div class="trade-instructions-itePricem">
          <p class="item-label  bold">Stop Price</p>
          <irb-number-text-box #stopPriceElem [disabled]="stopPriceDisabled || pfs.updateOrderPayload.disableMode || mainPropertiesDisabled"
            [(value)]="stopPrice"
            [placeholder]="(isShowStopPriceVarious && actionType==='MultiEdit') ? 'Various' : ''"
            places="2" min="0" max="1000000000"
            [invalidRangeMessage]="priceRangeMessage"
            (focusin)="onStopPriceTapped($event)" (focusout)="onStopPriceChange($event)"
          width="90px"></irb-number-text-box>
        </div>
      }
      <div class="trade-instructions-item">
        <p class="item-label  bold">Expiration Type</p>
        <irb-dropdown-filter #expirationTypeElem (search)="getExpTypes($event)"
          [(value)]="expTypeSelected"
          [disabled]="expirationTypeDisabled || pfs.updateOrderPayload.disableMode || mainPropertiesDisabled"
          [placeholder]="actionType === 'MultiEdit' ? 'Various': ' '"
          size="15" hoverPanelWidth="150"
        (selection)="expirationTypeChanged($event)"></irb-dropdown-filter>
      </div>
      <div class="trade-instructions-item">
        <p class="item-label  bold">Expiration Date</p>
        @if (!isShowExpDateVarious && !(expirationDateDisabled)) {
          <input #expirationDateElem
            pInputText
            [disabled]="expirationDateDisabled || pfs.updateOrderPayload.disableMode || mainPropertiesDisabled"
            class="expiration-date" type="date" [attr.min]="tomorrowDate" [attr.max]="daySixMonthsAfter" [(ngModel)]="expirationDate"
            (focus)="expirationDateTapped($event)" (blur)="expirationDateChanged($event)"
            tooltip
            [tooltipTitle]="expirationDateTooltipMsg"
            [tooltipPosition]="'top'"
            tooltipClass="error"
            [tooltipHorizontalOffset]="8">
        }
        @if (isShowExpDateVarious ||
          (expirationDateDisabled)) {
<input type="text" pInputText class="date-various" [placeholder]="expirationDateDisabled ? (expTypeSelected?.id === 'GT6M' && daySixMonthsAfterDisplay || 'n/a') :
      (isShowExpDateVarious? 'Various': ((expirationDateDisabled || pfs.updateOrderPayload.disableMode || mainPropertiesDisabled) ?
      (expTypeSelected?.id === 'GT6M' && daySixMonthsAfterDisplay || 'n/a') : ' '))"
            [disabled]="expirationDateDisabled || pfs.updateOrderPayload.disableMode || mainPropertiesDisabled"
            (click)="isShowExpDateVarious=false">
        }
      </div>
    </div>
    <div style="height:15px"></div>
    @if (data?.securityType === 'EQUITY' || isTestMode) {
      <div class="trade-instructions">
        <div class="trade-instructions-item nowrap"
             tooltip
             [tooltipTitle]="actionType === 'Replace' ? 'Not held instructions cannot be edited.' : ''"
             [tooltipPosition]="'top'"
             [tooltipHorizontalOffset]="8">
          @if (!isShowNotHeldVarious) {
            <p-checkbox
              binary="true"
              [(ngModel)]="notHeld"
              (onChange)="notHeldChanged()"
              [disabled]="notHeldDisabled || pfs.updateOrderPayload.disableMode || mainPropertiesDisabled || actionType === 'Replace'"
              style="vertical-align:middle;"
            ></p-checkbox>
          }
          @if (isShowNotHeldVarious) {
            <img src="/assets/images/checkboxIndeterminate.svg"
              (click)="notHeldVariousClicked()" style="margin: 0px 3px -3px 0">
          }
          <span class="lbl-not-held">Not Held{{isShowNotHeldVarious ? '(Various)' : ''}}</span>
        </div>
        @if (notHeldPermissions) {
          <div class="trade-instructions-item nowrap">
            <span class="item-label inline">Destination</span>
            <irb-dropdown-filter #notHeldDestinationElem (search)="getNotHeldDestinations($event)"
              [(value)]="notHeldDestinationSelected"
              [disabled]="notHeldDestinationDisabled || pfs.updateOrderPayload.disableMode || mainPropertiesDisabled"
              size="15" hoverPanelWidth="150"
            (selection)="notHeldDestinationChanged($event)"></irb-dropdown-filter>
          </div>
          @if (layoutFieldsShowHide.destiDepField && notHeld) {
            <div class="trade-instructions-item nowrap">
              <p class="item-label inline">Algorithm
                @if ((notHeldDestinationSelected?.id === 'VIRTU' || notHeldDestinationSelected?.id === 'CITADEL') && notHeld) {
                  <span class="algo-info-wrapper"
                        (mouseenter)="showAlgoInfo = true"
                        (mouseleave)="showAlgoInfo = false">
                    <span class="infoIcon"></span>
                    @if (showAlgoInfo) {
                      <div class="algo-info-box">
                        <div><b>POV:</b> A POV (Percentage of Volume) trading strategy is an algorithmic execution strategy where an order is sliced into smaller pieces and executed as a fixed percentage of the overall market trading volume. By default, the POV calculation will exclude blocks of 10,000 shares of $200,000.</div>
                        <div style="margin-top:8px;"><b>VWAP:</b> A VWAP (Volume-Weighted Average Price) strategy is an algorithmic execution strategy that spreads an order out based on historical trading volume distributions over a specified time horizon and will complete if marketable.</div>
                        <div style="margin-top:8px;"><b>TWAP:</b> A TWAP (Time-Weighted Average Price) strategy is an algorithmic execution strategy that spreads an order evenly over a specified time horizon and will complete if marketable.</div>
                      </div>
                    }
                  </span>
                }
              </p>
              <irb-dropdown-filter #notHeldAlgorithmElem (search)="getAlgorithms($event)"
                [(value)]="algorithmSelected"
                size="15" hoverPanelWidth="150"
                [placeholder]="actionType==='MultiEdit'? 'Various': ' '"
              (selection)="algorithmChanged($event)"></irb-dropdown-filter>
            </div>
          }
        }
        @if (layoutFieldsShowHide.blockDeskDepFieldsLay  && notHeld) {
          <div class="trade-instructions-item nowrap">
            <span class="item-label inline">Contact number
              <span class="infoIcon" calltoaction [calltoactionTemplate]="contactNumberToolTipTemplateRef"></span>
            </span>
            <input type="tel" #blockDeskContact pInputText class="blockdesk-contact" (focus)="blockDeskContactTapped($event)"
              (blur)="blockDeskContactChanged($event)"
              [(ngModel)]="userContactNo" [disabled]="pfs.updateOrderPayload.disableMode || mainPropertiesDisabled"
              tooltip
              [tooltipTitle]="blockDeskContactTooltipMsg"
              [tooltipPosition]="'top'"
              tooltipClass="error"
              [tooltipHorizontalOffset]="8">
            <span>&nbsp;XXX-XXX-XXXX</span>
          </div>
        }
      </div>
      <div style="height:15px"></div>
      @if (notHeldPermissions && layoutFieldsShowHide?.algorithmDepFieldsLayDisplay) {
        <div class="trade-instructions block">
          @if (layoutFieldsShowHide?.fillReportingLay) {
            <div class="trade-instructions-item">
              <p class="item-label inline">Fill Reporting</p>
              <irb-dropdown-filter #ordNotHeldFillPolicyElem (search)="getOrdNotHeldFillPolicys($event)"
                [value]="ordNotHeldFillPolicySelected"
                [disabled]="ordNotHeldFillPolicyDisabled || pfs.updateOrderPayload.disableMode || mainPropertiesDisabled"
                size="15" hoverPanelWidth="150"
                [placeholder]="actionType==='MultiEdit'? 'Various': ' '"
              (selection)="ordNotHeldFillPolicyChanged($event)"></irb-dropdown-filter>
            </div>
          }
          @if (layoutFieldsShowHide?.participationLay) {
            <div class="trade-instructions-item">
              <p class="item-label inline">Participation Rate(%)</p>
              <irb-number-text-box #ordNotHeldPartRateElem
                [disabled]="ordNotHeldPartRateDisabled || pfs.updateOrderPayload.disableMode || mainPropertiesDisabled"
                [(value)]="ordNotHeldPartRateValue" places="0" min="1" max="80"
                [invalidRangeMessage]="ordNotHeldPartRateInvalidMessage"
              (focusout)="onOrdNotHeldPartRateChanged($event)" width="90px"></irb-number-text-box>
            </div>
          }
          @if (layoutFieldsShowHide?.startTimeLay) {
            <div class="trade-instructions-item">
              <p class="item-label inline">Start Time(ET)</p>
              <input #ordNotHeldStartTimeElem type="time" class="start-end-time" name="ordNotHeldStartTime"
                pInputText
                [(ngModel)]="ordNotHeldStartTime"
                [min]="ordNotHeldMinTime" [max]="ordNotHeldMaxTime" step="1800" list="calltimeslist"
                (focus)="ordNotHeldStartTimeTapped($event)" (blur)="ordNotHeldStartTimeChanged($event)"
                tooltip
                [tooltipTitle]="ordNotHeldStartTimeTooltipMsg"
                [tooltipPosition]="'top'"
                tooltipClass="error"
                [tooltipHorizontalOffset]="8">
            </div>
          }
          @if (layoutFieldsShowHide?.endTimeLay) {
            <div class="trade-instructions-item">
              <p class="item-label inline">End Time(ET)</p>
              <input #ordNotHeldEndTimeElem type="time" class="start-end-time" name="ordNotHeldEndTime"
                pInputText
                [(ngModel)]="ordNotHeldEndTime"
                [min]="ordNotHeldMinTime" [max]="ordNotHeldMaxTime" step="1800" list="calltimeslist"
                (focus)="ordNotHeldEndTimeTapped($event)" (blur)="ordNotHeldEndTimeChanged($event)"
                tooltip
                [tooltipTitle]="ordNotHeldEndTimeTooltipMsg"
                [tooltipPosition]="'top'"
                tooltipClass="error"
                [tooltipHorizontalOffset]="8">
            </div>
          }
          @if (layoutFieldsShowHide?.auctionOnlyLay) {
            <div class="trade-instructions-item" style="margin-right: 15px; padding-top: 2px;">
              <p-checkbox binary="true" [(ngModel)]="ordNotHeldAuctionOnly"
              (onChange)="ordNotHeldAuctionOnlyChanged($event)" inputId="tradeitem1"></p-checkbox>
              <label for="tradeitem1">Auction Only</label>
            </div>
          }
          @if (layoutFieldsShowHide?.incExclLay) {
            <div class="trade-instructions-item">
              <p class="item-label inline">Include/Exclude</p>
              <irb-dropdown-filter #includeExcudeElem (search)="getOrdNotHeldIncludeExclude($event)"
                [value]="ordNotHeldIncludeExcludeSelected"
                [disabled]="ordNotHeldIncludeExcludeDisabled || pfs.updateOrderPayload.disableMode || mainPropertiesDisabled"
                size="15" hoverPanelWidth="150"
              (selection)="ordNotHeldIncludeExcludeChanged($event)"></irb-dropdown-filter>
            </div>
          }
          @if (layoutFieldsShowHide?.maxVolumeLay) {
            <div class="trade-instructions-item">
              <p class="item-label inline">{{layoutFieldsShowHide.maxVolumeLabel}}</p>
              <irb-number-text-box #ordNotHeldMaxVolPctElem
                [disabled]="ordNotHeldMaxVolPctDisabled || pfs.updateOrderPayload.disableMode || mainPropertiesDisabled"
                [attr.required]="ordNotHeldMaxVolPctRequired"
                [isRequired]="ordNotHeldMaxVolPctRequired"
                [(value)]="ordNotHeldMaxVolPctValue" places="0" min="1" max="99"
                [invalidRangeMessage]="ordNotHeldMaxVolPctInvalidMessage"
              (focusout)="ordNotHeldMaxVolPctChanged($event)" width="90px"></irb-number-text-box>
            </div>
          }
          @if (layoutFieldsShowHide?.displaySizeLay) {
            <div class="trade-instructions-item">
              <p class="item-label inline">Display Size</p>
              <irb-number-text-box #ordNotHeldMaxDispSizeElem
                [disabled]="ordNotHeldMaxDispSizeDisabled || pfs.updateOrderPayload.disableMode || mainPropertiesDisabled"
                [(value)]="ordNotHeldMaxDispSizeValue" places="0" [min]="0" [max]="ordNotHeldDisplaySizeMax"
                [invalidRangeMessage]="ordNotHeldMaxDispSizeInvalidMessage"
              (focusout)="ordNotHeldMaxDispSizeChanged($event)" width="90px"></irb-number-text-box>
            </div>
          }
          @if (layoutFieldsShowHide?.styleLay) {
            <div class="trade-instructions-item">
              <p class="item-label inline">Style</p>
              <irb-dropdown-filter #ordNotHeldStyleElem (search)="getOrdNotHeldStyles($event)"
                [value]="ordNotHeldStyleSelected"
                [disabled]="ordNotHeldStyleDisabled || pfs.updateOrderPayload.disableMode || mainPropertiesDisabled"
                size="15" hoverPanelWidth="150"
                [placeholder]="actionType==='MultiEdit'? 'Various': ' '"
              (selection)="ordNotHeldStyleChanged($event)"></irb-dropdown-filter>
            </div>
          }
          @if (layoutFieldsShowHide?.iWPriceLayDisplay) {
            <div class="trade-instructions-item">
              <p class="item-label inline">I Would Price</p>
              <irb-number-text-box #ordNotHeldIWPriceElem
                [disabled]="ordNotHeldIWPriceDisabled || pfs.updateOrderPayload.disableMode || mainPropertiesDisabled"
                [(value)]="ordNotHeldIWPriceValue" places="2" min="0"
                [invalidRangeMessage]="ordNotHeldIWPriceInvalidMessage"
              (focusout)="ordNotHeldIWPriceChanged($event)" width="90px"></irb-number-text-box>
            </div>
          }
        </div>
      }
    }
  }
  <div class="trade-instructions dblock">
    <div class="trade-instructions-item">
      <span class="lbl-destination">Trade Authorization:</span>
    </div>
    <div class="trade-instructions-item" style="margin-right: 15px;">
      @if (!isSolictedVarious) {
        <p-checkbox binary="true" [(ngModel)]="isSolicited"
          [disabled]="pfs.updateOrderPayload.disableMode"
                    style="vertical-align:middle;"
        (onChange)="authSolicitedChanged()"></p-checkbox>
      }
      @if (isSolictedVarious) {
        <img src="/assets/images/checkboxIndeterminate.svg"
          (click)="solicitedVariousClicked()" style="margin: 0px 3px -3px 0">
      }
      <span class="lbl-not-held">Solicited{{isSolictedVarious ? '(Various)' : ''}}</span>
    </div>
    <div class="trade-instructions-item">
      @if (!isDiscretionaryVarious) {
        <p-checkbox binary="true" [(ngModel)]="isDiscretionary"
          [disabled]="pfs.updateOrderPayload.disableMode"
                    style="vertical-align:middle;"
        (onChange)="authDiscretionaryChanged()"></p-checkbox>
      }
      @if (isDiscretionaryVarious) {
        <img src="/assets/images/checkboxIndeterminate.svg"
          (click)="discretionaryVariousClicked()" style="margin: 0px 3px -3px 0">
      }
      <span class="lbl-not-held">Discretionary{{isDiscretionaryVarious ? '(Various)' : ''}}</span>
    </div>
  </div>
  <div [ngClass]="{'block': data?.securityType === 'EQUITY'}">The designations will not appear on the Client's trade confirmation and the notation on the platform is for advisor audit purposes only.</div>
  <div *ngIf="data?.securityType === 'EQUITY'">
    <div class="block">Not Held orders routed to the Advisor Services Block Desk will incur additional charges, please reference the Charles Schwab Pricing Guide for Clients of Independent Investment Advisors ("Pricing Guide") for more information. Or contact the block desk at 800-766-9922 for information.</div>
    <div>For Algorithm Strategies, if VWAP/TWAP check box for (include the close) is selected, you cannot cancel the order after 3:50ET.</div>
  </div>
</div>

<ng-template #contactNumberToolTipTemplateRef>
  After the order is submitted, the Block Desk will call this number for instructions on how to work the order.
  Note: If you do not receive a call within 5 minutes of submitting the order, please call the Block
  Desk{{parentObj.blockDeskContact ? ' at ' + parentObj.blockDeskContact : ''}}.
</ng-template>
<datalist id="calltimeslist">
  <option value="09:30">
    <option value="10:00">
      <option value="10:30">
        <option value="11:00">
          <option value="11:30">
            <option value="12:00">
              <option value="12:30">
                <option value="13:00">
                  <option value="13:30">
                    <option value="14:00">
                      <option value="14:30">
                        <option value="15:00">
                          <option value="15:30">
                            <option value="16:00">
                            </datalist>
